module.exports = __webpack_public_path__ + "media/desktop-landing-video.631dceff.mp4";